export enum IncentiveMethod {
  Bonus = 0,
  //Reimbursement = 1,
  EmployeeAdj = 2,
  MiscWork = 3,
  SpotPay = 4,
  VacationAccrual = 5,
  SickDays = 6, //disabled until we have a use case and tested
  Holiday = 7
}

export const IncentiveMethodMapping: Record<IncentiveMethod, string> = {
  [IncentiveMethod.Bonus]: 'Bonus',
  //[IncentiveMethod.Reimbursement]: 'Reimbursement',
  [IncentiveMethod.EmployeeAdj]: 'Employee Adj.',
  [IncentiveMethod.MiscWork]: 'Misc. Work',
  [IncentiveMethod.SpotPay]: 'Spot Pay',
  [IncentiveMethod.VacationAccrual]: 'Vacation Days',
  [IncentiveMethod.SickDays]: 'Sick Days',
  [IncentiveMethod.Holiday]: 'Holiday'
};
